import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// libs
import { UISharedModule } from '@moduurnv2/features';
import { HeaderComponent, NotificationComponent, AlertPopupComponent,PersonCountComponent, LoaderComponent } from './components';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    UISharedModule,
  ],
  declarations: [HeaderComponent, NotificationComponent,AlertPopupComponent,PersonCountComponent,LoaderComponent],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    UISharedModule,
    HeaderComponent,
    NotificationComponent,
    AlertPopupComponent,
    PersonCountComponent,
    LoaderComponent
  ],
})
export class UIModule {}
